module.exports = __webpack_public_path__ + "static/media/Porsche_logo.02291dd0.png";